import React from 'react';

import {
    Box,
    Flex,
    Text
} from "@chakra-ui/react";
import {WarningIcon} from "@chakra-ui/icons";

const CharacterCounter = ({maxLength = 200, text = ''}) => {

    const plainTextLength = text ? text.replace(/<[^>]*>/g, '').length : 0;
    const charactersRemaining = maxLength - plainTextLength;
    const hasError = charactersRemaining < 0;

    return (
        <Box>
            <Flex fontSize='sm'>
                <Text mr={1} color={charactersRemaining < 0 ? 'red' : 'default'}>{charactersRemaining}</Text>
                <Text>{`Zeichen von ${maxLength} möglichen Zeichen`}</Text>
            </Flex>
            {hasError && (
                <Flex fontSize='sm' mt={1} alignItems="center" color="red.500">
                    <WarningIcon mr={1}/>
                    <Text>Die maximale Anzahl an Zeichen beträgt {maxLength}</Text>
                </Flex>
            )}
        </Box>
    );
};

export default CharacterCounter;
